/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Modal } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import './ModalVideo.css';
import closeIcon from '../../res/close-icon.svg';

export default (props) => {
  const {
    show, handleClose, url, ...rest
  } = props;
  return (
    <Modal className="modal-video" show={show} onHide={handleClose}>
      <div>
        <img src={closeIcon} onClick={handleClose} className="close-icon" alt="close" />
      </div>
      <ReactPlayer
        url={url}
        config={{
          vimeo: {
            playerOptions: {
              title: false,
              portrait: false,
            },
            preload: true,
          },
        }}
        {...rest}
      />
    </Modal>
  );
};
